/**
 * Checks if browser supports shadow dom.
 * @returns {boolean}
 */
export function browserSupportsShadowDom(): boolean {
  return window.ShadowRoot != null;
}

/**
 * Checks if web component comes with shadow root.
 * @param {any} hostElement
 * @returns {boolean}
 */
export function componentHasShadowRoot(hostElement: any): boolean {
  return hostElement.shadowRoot != null;
}

/**
 * Checks if a it's a shadowed web component that is used in modern browser (FF, Chrome in dev build mode) which allows to use styles in shadow root.
 * @param {any} hostElement
 * @returns {boolean}
 */
export function componentHasShadowStyle(hostElement: any): boolean {
  return (
    componentHasShadowRoot(hostElement) &&
    hostElement.shadowRoot.styleSheets != null &&
    hostElement.shadowRoot.styleSheets.length > 0
  );
}

/**
 * Checks if a web component is coming with shadow root that allows to use adopted style sheets.
 * @param {any} hostElement
 * @returns {boolean}
 */
export function componentHasAdoptedShadowStyle(hostElement: any): boolean {
  return hostElement.shadowRoot != null && (hostElement.shadowRoot as any).adoptedStyleSheets != null;
}
